"use strict";

import Vue from 'vue'
import EventBus from '@/vue/events/event-bus'
window.loading = false;

$.ajaxSetup({
  beforeSend: function (xhr, settings) {
    var index = ''
    var token_val = ''
    var enableLoading = false
    if(settings.data){
      var data = settings.data.split('&')
      var data = data.indexOf("enableLoading=true")
      enableLoading = (data >= 0) ?  true: false // if pass by params in ajax
      settings.data = settings.data.replace("&enableLoading=false","")
      settings.data = settings.data.replace("&enableLoading=true","")
      var url = settings.data
    } else if (settings.type == 'GET') {
      var data = settings.url.indexOf("enableLoading=true")
      enableLoading = (data >= 0) ? true: false // if pass by params in ajax
      settings.url = settings.url.replace("&enableLoading=false","")
      settings.url = settings.url.replace("&enableLoading=true","")
      var url = settings.url
    }
    settings.url = settings.url.replace("?enableLoading=false","")
    settings.url = settings.url.replace("?enableLoading=true","")
    if(url){
      //if token= param exist, replace with ''
      var valid = url.indexOf("&")
      if(valid >= 0){
        var suburl = url.split('&')
        var delimiter = '&'
      } else {
        var suburl = url.split('?')
        var delimiter = '?'
      }

      suburl.forEach(function(value, i){
        if(value.substring(0,6) == 'token='){
          index = i
          token_val = value.split('=')
          if(settings.data){
            settings.data = url.replace(delimiter + suburl[index], "")
          } else if (settings.type == 'GET') {
            settings.url = url.replace(delimiter + suburl[index], "")
          }
          xhr.setRequestHeader('TOKEN', decodeURIComponent(token_val[1]));
        }
      })
    }
    if(enableLoading){
      EventBus.$emit('enableLoading',enableLoading)
    }
    if ($.inArray(settings.type, ['POST', 'PUT', 'DELETE', 'PATCH']) > -1) {
      if (!_.isUndefined(settings.data)) {
        var csrf = {
          'csrf_name': function () { return $('meta[name="csrf_name"]').attr('content'); }(),
          'csrf_value': function () { return $('meta[name="csrf_value"]').attr('content'); }()
        };
        //settings.data += '&' + $.param(csrf);
      }
      return true;
    }
  },
})

$(document).ajaxSuccess(function(event, xhr, options) {
 // EventBus.$emit('enableLoading',false)

  if(!_.isUndefined(xhr.responseJSON)) {
    if(xhr.responseJSON.redirect){
      window.location.href = xhr.responseJSON.redirect;
    }
  }
})

$(document).ajaxComplete(function(event, xhr, options) {
  if(window.navigator.userAgent.indexOf('Safari')>=0 && window.navigator.userAgent.indexOf('Chrome')==-1){
    $('.gridContainer').height('90vh'); 
    $('.gridContainer').css('overflow-y','auto');
  }
  if (xhr.getResponseHeader('X-Auth') == '0') {
      window.location = 'login';
  }

  if( xhr.status === 0 ) {
    location.reload()
  }

  if(xhr.getResponseHeader('X-Csrf-Name') && xhr.getResponseHeader('X-Csrf-Value')){
    var csrf = {
      'csrf_name': xhr.getResponseHeader('X-Csrf-Name'),
      'csrf_value': xhr.getResponseHeader('X-Csrf-Value')
    };

    $.each(csrf, function (k, v) {
      $('meta[name="' + k + '"]').attr('content', v);
    });
  }
})

Vue.prototype.$ajax = $.ajax



// WEBPACK FOOTER //
// ./resources/score/js/core/ajax-http-interceptor.js